<template>
  <DownloadScheme />
  <div class="spinner-page" v-if="areGrantDetailsLoading">
    <q-spinner class="spinner" color="primary" size="3em" />
  </div>
  <div
    v-else
    class="grant-details-page"
    :class="isContrast != 'false' && isContrast != false ? 'high-contrast' : ''"
  >
    <ShareGrant />
    <SaveScheme />
    <div class="column navbox-column">
      <div class="navbox-relative">
        <div class="nav-box">
          <div
            class="navbox-item"
            @click="scrollToIt('introduction')"
            v-if="scheme.introduction"
          >
            Omschrijving
          </div>
          <q-separator color="white" v-if="scheme.introduction" />
          <div
            class="navbox-item"
            @click="scrollToIt('body')"
            v-if="scheme.body"
          >
            Samenvatting
          </div>
          <q-separator color="white" v-if="scheme.body" />
          <div
            class="navbox-item"
            @click="scrollToIt('criteria')"
            v-if="isVind && scheme.criteria"
          >
            Criteria
          </div>
          <q-separator color="white" v-if="isVind && scheme.criteria" />
          <div
            class="navbox-item"
            @click="scrollToIt('bijdrage')"
            v-if="isVind && scheme.financialInformation"
          >
            Bijdrage
          </div>
          <q-separator
            color="white"
            v-if="isVind && scheme.financialInformation"
          />
          <div
            class="navbox-item"
            @click="scrollToIt('docsandlinks')"
            v-if="
              isVind &&
                ((scheme.schemeLinks && scheme.schemeLinks.length > 0) ||
                  (scheme.schemeDocuments && scheme.schemeDocuments.length > 0))
            "
          >
            Documenten en links
          </div>
          <q-separator
            color="white"
            v-if="
              isVind &&
                ((scheme.schemeLinks && scheme.schemeLinks.length > 0) ||
                  (scheme.schemeDocuments && scheme.schemeDocuments.length > 0))
            "
          />
          <div
            class="navbox-item"
            @click="scrollToIt('news')"
            v-if="scheme.news && scheme.news.length > 0"
          >
            Nieuws
          </div>
          <q-separator
            color="white"
            v-if="scheme.news && scheme.news.length > 0"
          />
          <div
            class="navbox-item"
            @click="scrollToIt('orgs-list')"
            v-if="organisationsList && organisationsList.length > 0"
          >
            Organisaties
          </div>
          <q-separator
            color="white"
            v-if="scheme.news && scheme.news.length > 0"
          />
          <div
            class="navbox-item"
            @click="scrollToIt('calls')"
            v-if="
              isVind &&
                scheme.children &&
                scheme.children.length > 0 &&
                !scheme.isCall
            "
          >
            Gerelateerde openstelling
          </div>
          <div
            class="navbox-item"
            v-if="isVind && scheme.isCall"
            @click="goToParent()"
          >
            Gerelateerde regeling
          </div>
        </div>
      </div>
    </div>

    <div class="page-details">
      <div class="column pagetop">
        <div class="column">
          <div class="row heading-scheme">
            <div class="column scheme-name-and-org">
              <div class="col-8">
                <h2 class="title"><span v-html="scheme.name"></span></h2>
              </div>
            
            </div>

            <div>
              <q-badge rounded class="badge">{{
                scheme.itemType == 0 ? 'Regeling' : 'Openstelling'
              }}</q-badge>
            </div>
          </div>
          <div class="row q-mt-sm" v-if="isVind">
            <i
              class="las la-2x la-save action-icon "
              @click="enableSaveScheme(scheme.id)"
            >
              <q-tooltip>
                Opslaan
              </q-tooltip></i
            >
            <i
              class="las la-2x la-share action-icon q-ml-md"
              @click="shareGrant()"
            >
              <q-tooltip>
                Delen
              </q-tooltip></i
            >
            <i
              class="las la-2x la-download action-icon q-ml-md"
              @click="downloadScheme(scheme.id)"
            >
              <q-tooltip>
                Downloaden
              </q-tooltip></i
            >
          </div>
        </div>
      </div>

      <div class="column main-page">
        <div class="top-details row">
          <div class="topinfo-item">
            <span class="topinfo-item-heading">Deadline</span>
            <span class="topinfo-item-value">{{
              scheme.currentDeadlineText ?? '-'
            }}</span>
          </div>
          <div v-if="!scheme.isCall" class="topinfo-item">
            <span class="topinfo-item-heading">Aanvraagtermijn</span>
            <span class="topinfo-item-value">
              {{
                scheme.applicationTerm !== 'Onbepaald'
                  ? scheme.applicationTerm
                  : scheme.applicationTermText &&
                    scheme.applicationTermText !== ''
                  ? scheme.applicationTermText
                  : scheme.applicationTerm
              }}
            </span>
          </div>
          <div v-if="!scheme.isCall" class="topinfo-item">
            <span class="topinfo-item-heading">Bereik</span>
            <span class="topinfo-item-value">{{ scheme.scope }}</span>
          </div>

          <div class="topinfo-item">
            <span class="topinfo-item-heading">Status</span>
            <span class="topinfo-item-value">{{ statusNL ?? '-' }}</span>
          </div>
        </div>

        <div class="top-details row" v-if="isVind">
          <div v-if="!scheme.isCall" class="topinfo-item">
            <span class="topinfo-item-heading">Indienprocedure</span>
            <span class="topinfo-item-value procedure">
              {{ scheme.applicationProcedure ?? '-' }}
            </span>
          </div>
          <div class="topinfo-item">
            <span class="topinfo-item-heading">Minimale bijdrage</span>
            <span class="topinfo-item-value">
              <span
                v-if="!scheme.minAmount || scheme.minAmount < 1"
                class="detail-value"
                >Onbepaald
              </span>
              <span v-if="scheme.minAmount && scheme.minAmount > 1">{{
                formattedMinAmount ?? '-'
              }}</span>
            </span>
          </div>
          <div class="topinfo-item">
            <span class="topinfo-item-heading">Maximale bijdrage</span>
            <span class="topinfo-item-value">
              <span
                v-if="!scheme.maxAmount || scheme.maxAmount < 1"
                class="detail-value"
                >Onbepaald
              </span>
              <span v-if="scheme.maxAmount && scheme.maxAmount > 1">{{
                formattedMaxAmount ?? '-'
              }}</span>
            </span>
          </div>
          <div class="topinfo-item">
            <span class="topinfo-item-heading">Budget</span>
            <div
              class="topinfo-item-value-budget budget"
              v-if="scheme.budget"
              v-html="scheme.budget"
            ></div>
            <div class="topinfo-item-value budget" v-else>
              -
            </div>
          </div>
        </div>
        <div class="top-details row">
          <div class="topinfo-item" v-if="isVind">
            <span class="topinfo-item-heading">Looptijd</span>
            <span class="topinfo-item-value budget">{{
              scheme.duration ?? '-'
            }}</span>
          </div>
          <div
            class="topinfo-item"
            v-if="
              scheme.complexityRating != null && scheme.complexityRating > 0
            "
          >
            <span class="topinfo-item-heading">Moeilijkheid</span>
            <div style="text-align:left">
              <q-rating
                v-model="scheme.complexityRating"
                size="sm"
                :max="5"
                :color-selected=getRatingColor(scheme.complexityRating)
                color="grey-13"
                icon="circle"
                icon-selected="circle"
                readonly
              ></q-rating>
              <q-tooltip anchor="bottom middle" self="bottom middle" class="rating-tooltip" style="color: black; background-color:white; font-size: small;">
                  {{ getComplexityRatingLabel(scheme.complexityRating) }}
              </q-tooltip>
            </div>
          </div>
          <div
            class="topinfo-item"
            v-if="
              scheme.chanceOfSuccessRating != null &&
                scheme.chanceOfSuccessRating > 0
            "
          >
            <span class="topinfo-item-heading">Slaagkans</span>
            <div style="text-align:left">
              <q-rating
                v-model="scheme.chanceOfSuccessRating"
                size="sm"
                :max="5"
                :color-selected=getChanceOfSuccessRatingColor(scheme.chanceOfSuccessRating)
                color="grey-13"
                icon="circle"
                icon-selected="circle"
                readonly
              ></q-rating>
              <q-tooltip anchor="bottom middle" self="bottom middle" class="rating-tooltip" style="color: black; background-color:white; font-size: small;">
                {{ getChanceOfSuccessRatingLabel(scheme.chanceOfSuccessRating) }}
              </q-tooltip>
            </div>
          </div>
          <div
            class="topinfo-item"
            v-if="
              scheme.timeForApplicationRating != null &&
                scheme.timeForApplicationRating > 0
            "
          >
            <span class="topinfo-item-heading">Tijdsduur</span>
            <div style="text-align:left">
              <q-rating
                v-model="scheme.timeForApplicationRating"
                size="sm"
                :max="5"
                :color-selected=getRatingColor(scheme.timeForApplicationRating)
                color="grey-13"
                icon="circle"
                icon-selected="circle"
                readonly
              >
              </q-rating>
              <q-tooltip anchor="bottom middle" self="bottom middle" class="rating-tooltip" style="color: black; background-color:white; font-size: small;">
                {{ getTimeForApplicationRatingLabel(scheme.timeForApplicationRating) }}
              </q-tooltip>
            </div>
          </div>
        </div>
        <q-separator class="q-mt-lg" />

        <div class="row page-lower">
          <div class="column">
            <!--     <div id="applicationProcedure"></div>
            <div class="large-item" v-if="scheme.applicationProcedure">
              <span class="box-title">
                Indienprocedure
              </span>
              <div class="introduction">
                <div v-html="scheme.applicationProcedure"></div>
              </div>
              <div id="body"></div>
            </div>
            <q-separator
              class="full-width-separator"
              v-if="scheme.applicationProcedure"
            /> -->
            <div id="introduction"></div>

            <div class="large-item" v-if="scheme.introduction">
              <span class="box-title">
                Omschrijving
              </span>
              <div class="introduction">
                <div v-html="scheme.introduction"></div>
              </div>
              <div id="body"></div>
            </div>

            <q-separator
              class="full-width-separator"
              v-if="scheme.introduction"
            />

            <div class="large-item" v-if="scheme.body">
              <span class="box-title">
                Samenvatting
              </span>
              <div v-html="scheme.body" class="introduction"></div>
              <div id="criteria"></div>
            </div>
            <q-separator class="full-width-separator" v-if="scheme.body" />

            <div v-if="scheme.criteria && isVind" class="large-item">
              <span class="box-title">
                Criteria
              </span>
              <div v-html="scheme.criteria" class="introduction"></div>
              <div id="bijdrage" name="bijdrage"></div>
            </div>
            <q-separator class="full-width-separator" v-if="scheme.criteria" />

            <div
              v-if="scheme.financialInformation && isVind"
              class="large-item"
            >
              <span class="box-title">
                Bijdrage
              </span>
              <div
                v-if="scheme.financialInformation"
                v-html="scheme.financialInformation"
                class="introduction"
              ></div>
              <div id="docsandlinks"></div>
            </div>

            <q-separator
              class="full-width-separator"
              v-if="
                isVind &&
                  ((scheme.schemeLinks && scheme.schemeLinks.length > 0) ||
                    (scheme.schemeDocuments &&
                      scheme.schemeDocuments.length > 0))
              "
            />
            <div
              v-if="
                isVind &&
                  ((scheme.schemeLinks && scheme.schemeLinks.length > 0) ||
                    (scheme.schemeDocuments &&
                      scheme.schemeDocuments.length > 0))
              "
              class="large-item lg-item-width"
            >
              <span class="box-title">
                Externe informatie
              </span>
              <div
                class="scheme-links-sorted"
                v-if="sortedLinksAndDocs && sortedLinksAndDocs.length > 0"
              >
                <div
                  v-for="link in sortedLinksAndDocs"
                  :key="link.id"
                  class="links-list-sorted"
                >
                  <div
                    v-if="
                      link.url &&
                        link.url.length > 0 &&
                        link.documentType == 'Useful links'
                    "
                    class="sorted-link row"
                  >
                    <i class="las la-2x la-link link-icon"></i>

                    <span
                      class="doc-type q-ml-sm"
                      v-if="link.documentType == 'Useful links'"
                    >
                      Nuttige links
                    </span>
                    <span class="doc-type q-ml-sm" v-else>
                      {{ link.documentType }}
                    </span>
                    <a
                      class="link-item q-ml-md"
                      :href="link.url"
                      target="_blank"
                    >
                      {{ link.text }}
                    </a>
                  </div>
                </div>
              </div>
              <span class="box-title q-mt-lg">
                Overige links en bestanden
              </span>
              <div
                class="scheme-links-sorted"
                v-if="sortedLinksAndDocs && sortedLinksAndDocs.length > 0"
              >
                <div
                  v-for="link in sortedLinksAndDocs"
                  :key="link.id"
                  class="links-list-sorted"
                >
                  <div
                    v-if="
                      link.url &&
                        link.url.length > 0 &&
                        link.documentType != 'Useful links' &&
                        link.documentType != 'Visual Ping links' &&
                        !link.documentType.includes('Vervallen')
                    "
                    class="sorted-link row"
                  >
                    <i class="las la-2x la-link link-icon"></i>
                    <span class="doc-type q-ml-sm">
                      {{ link.documentType }}
                    </span>

                    <a
                      class="link-item q-ml-md"
                      :href="link.url"
                      target="_blank"
                    >
                      {{ link.text }}
                    </a>
                  </div>
                  <div
                    v-if="
                      !link.url &&
                        link.documentType != 'Useful links' &&
                        link.documentType != 'Visual Ping links' &&
                        !link.documentType.includes('Vervallen')
                    "
                    class="sorted-doc row"
                  >
                    <i
                      :class="iconBasedOnExtension(link.extension)"
                      class="link-icon"
                    ></i>
                    <span class="doc-type q-ml-sm">
                      {{ link.documentType }}
                    </span>

                    <div
                      class="link-item docname q-ml-md"
                      @click="download(link.id, link.name)"
                    >
                      {{ link.name }}
                    </div>
                  </div>
                </div>
              </div>

              <q-btn
                @click="updateSeeDeprecatedItems(true)"
                v-if="!seeDeprecatedItems"
                class="deprecated-btn row q-mt-sm"
                flat
                no-caps
                label="Zie vervallen"
                ><i class="las la-angle-down q-ml-xs"></i
              ></q-btn>

              <q-btn
                @click="updateSeeDeprecatedItems(false)"
                v-else
                class="deprecated-btn row q-mt-sm"
                flat
                no-caps
                label="Verberg vervallen"
              >
                <i class="las la-angle-up q-ml-xs"></i
              ></q-btn>
              <div
                class="scheme-links-sorted"
                v-if="
                  sortedLinksAndDocs &&
                    sortedLinksAndDocs.length > 0 &&
                    seeDeprecatedItems
                "
              >
                <div
                  v-for="link in sortedLinksAndDocs"
                  :key="link.id"
                  class="links-list-sorted"
                >
                  <div
                    v-if="
                      link.url &&
                        link.url.length > 0 &&
                        link.documentType != 'Useful links' &&
                        link.documentType != 'Visual Ping links' &&
                        link.documentType.includes('Vervallen')
                    "
                    class="sorted-link row"
                  >
                    <i class="las la-2x la-link link-icon"></i>
                    <span class="doc-type q-ml-sm">
                      {{ link.documentType }}
                    </span>

                    <a
                      class="link-item q-ml-md"
                      :href="link.url"
                      target="_blank"
                    >
                      {{ link.text }}
                    </a>
                  </div>
                  <div
                    v-if="
                      !link.url &&
                        link.documentType != 'Useful links' &&
                        link.documentType != 'Visual Ping links' &&
                        link.documentType.includes('Vervallen')
                    "
                    class="sorted-doc row"
                  >
                    <i
                      :class="iconBasedOnExtension(link.extension)"
                      class="link-icon"
                    ></i>
                    <span class="doc-type q-ml-sm">
                      {{ link.documentType }}
                    </span>

                    <div
                      class="link-item docname q-ml-md"
                      @click="download(link.id, link.name)"
                    >
                      {{ link.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <q-separator
              v-if="
                !isVind && organisationsList && organisationsList.length > 0
              "
              class="full-width-separator"
            />
            <div id="orgs-list"></div>

            <div
              class="large-item"
              v-if="
                !isVind && organisationsList && organisationsList.length > 0
              "
            >
              <span class="box-title">Meer informatie</span>

              <div class="scheme-news">
                <span class="links-title">Verstrekker</span>

                <div
                  v-for="organisation in organisationsList"
                  :key="organisation.id"
                  class="news-list"
                >
                  <div class="column">
                    <span class="organisation-name">
                      {{ organisation.name + ' (' + organisation.type + ')' }}
                    </span>
                    <div class="row">
                      <span
                        v-if="
                          organisation.addresses &&
                            organisation.addresses.length > 0
                        "
                        class="organisation-address q-ml-md"
                        >{{ organisation.addresses[0].addressLine1
                        }}{{
                          organisation.addresses[0].addressLine2 != null
                            ? `, ${organisation.addresses[0].addressLine2}`
                            : ''
                        }}{{
                          organisation.addresses[0].addressLine3 != null
                            ? `, ${organisation.addresses[0].addressLine3}`
                            : ''
                        }}
                      </span>
                      <span v-if="organisation.phone" class="q-ml-sm org-info">
                        {{ organisation.phone }}
                      </span>
                      <a
                        v-if="organisation.url"
                        class="q-ml-sm org-info"
                        :href="organisation.url"
                      >
                        {{ organisation.url }}
                      </a>
                      <span v-if="organisation.email" class="q-ml-sm org-info">
                        {{ organisation.email }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <q-separator class="full-width-separator" />

            <div id="news"></div>
            <q-separator
              class="full-width-separator"
              v-if="scheme.news && scheme.news.length > 0"
            />
            <div
              class="large-item"
              v-if="scheme.news && scheme.news.length > 0"
            >
              <span class="box-title">Nieuws </span>

              <div class="scheme-news">
                <span class="links-title">Nieuws afgelopen jaar</span>

                <div
                  v-for="news in newsInLastYear"
                  :key="news.id"
                  class="news-list"
                >
                  <div class="news-link-date">
                    <router-link
                      class="news-link"
                      style="text-decoration: underline"
                      :to="{ name: 'NewsDetails', params: { newsId: news.id } }"
                      target="_blank"
                      v-if="isNewsInLastYear(news.date)"
                    >
                      {{ news.title }}
                    </router-link>
                    <span
                      v-if="
                        news.date &&
                          news.date.length >= 10 &&
                          isNewsInLastYear(news.date)
                      "
                      class="news-date q-ml-md"
                    >
                      <!--   {{ news.date.substring(0, 10) }} -->
                      {{ formatDate(news.date) }}
                      <!--   {{ moment(news.date).format('YYYY-MM-DD') }} -->
                    </span>
                  </div>
                </div>

                <div class="older-news-list" v-if="showMore">
                  <span class="older-news-heading">Ouder nieuws</span>
                  <div
                    v-for="news in olderNews"
                    :key="news.id"
                    class="news-list"
                  >
                    <div class="news-link-date">
                      <router-link
                        class="news-link"
                        style="text-decoration: underline"
                        :to="{
                          name: 'NewsDetails',
                          params: { newsId: news.id },
                        }"
                        target="_blank"
                      >
                        {{ news.title }}
                      </router-link>
                      <span
                        v-if="news.date && news.date.length >= 10"
                        class="news-date q-ml-md"
                      >
                        {{ news.date.substring(0, 10) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <span
                v-if="!showMore && olderNews && olderNews.length > 0"
                @click="toggleShowMore()"
                class="news-btn"
                >Meer nieuws</span
              >
              <span v-if="showMore" @click="toggleShowMore()" class="news-btn"
                >Verberg ouder nieuws</span
              >
            </div>
            <q-separator
              v-if="isVind && organisationsList && organisationsList.length > 0"
              class="full-width-separator"
            />
            <div id="orgs-list"></div>

            <div
              class="large-item"
              v-if="isVind && organisationsList && organisationsList.length > 0"
            >
              <span class="box-title">Organisaties</span>

              <div class="scheme-news">
                <div
                  v-for="organisation in organisationsList"
                  :key="organisation.id"
                  class="news-list"
                >
                  <div class="column">
                    <span class="organisation-name">
                      {{ organisation.name + ' (' + organisation.type + ')' }}
                    </span>
                    <div class="row">
                      <span
                        v-if="
                          organisation.addresses &&
                            organisation.addresses.length > 0
                        "
                        class="organisation-address q-ml-md"
                        >{{ organisation.addresses[0].addressLine1
                        }}{{
                          organisation.addresses[0].addressLine2 != null
                            ? `, ${organisation.addresses[0].addressLine2}`
                            : ''
                        }}{{
                          organisation.addresses[0].addressLine3 != null
                            ? `, ${organisation.addresses[0].addressLine3}`
                            : ''
                        }}
                      </span>
                      <span v-if="organisation.phone" class="q-ml-sm org-info">
                        {{ organisation.phone }}
                      </span>
                      <a
                        v-if="organisation.url"
                        class="q-ml-sm org-info"
                        :href="organisation.url"
                      >
                        {{ organisation.url }}
                      </a>
                      <span v-if="organisation.email" class="q-ml-sm org-info">
                        {{ organisation.email }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <q-separator class="full-width-separator" />

            <div id="calls"></div>
            <div
              v-if="
                isVind &&
                  scheme.children &&
                  scheme.children.length > 0 &&
                  !scheme.isCall
              "
              class="large-item"
            >
              <span class="box-title q-pb-md">Gerelateerde openstellingen</span>
              <Calls />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="circle-container">
      <div id="pagetop" class="top-scroll" v-if="scY > 300">
        <i class="las la-2x la-angle-up up-icon" @click="toTop">
          <q-tooltip self="center left" :offset="[10, 10]"
            >Naar boven</q-tooltip
          >
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { onMounted, computed, ref } from 'vue';
import moment from 'moment';
import GrantsSevice from '../services/grants.service';
import store from '../store/index';
import grantsService from '../services/grants.service';
import ShareGrant from '../components/share-components/ShareScheme.vue';
import SaveScheme from '../components/SaveScheme.vue';
import Calls from '../components/Calls.vue';
import authHeader from '../helpers/auth-header';
import SchemeUtils from '../utils/schemes';
import OrganisationsUtils from '../utils/organisations';

import DownloadScheme from '../components/share-components/DownloadScheme.vue';
import UserService from '../services/userprofile.service';
export default {
  components: {
    ShareGrant,
    SaveScheme,
    Calls,
    DownloadScheme,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    onMounted(async () => {
      await UserService.getProfileConfiguration();
      const id = route.params.grantId;
      await GrantsSevice.getSchemeById(id, true);
      statusNL.value = SchemeUtils.translateStatus(scheme.value.status);
      OrganisationsUtils.generateOrganisationsForDetailsPage();

      window.addEventListener('scroll', handleScroll);
      window.scrollTo(0, 0);
    });

    const scheme = computed({
      get: () => store.state.grantItems.selectedGrant,
    });

    const shortIntro = computed({
      get: () => store.state.grantItems.shortIntro,
    });

    const showMore = ref(false);

    const columns = [
      {
        name: 'year',
        label: 'Year',
        field: 'year',
        sortable: true,
        align: 'left',
      },
      {
        name: 'amount',
        label: 'Amount (€)',
        field: 'amount',
        sortable: true,
        align: 'left',
      },
    ];

    const columnsOrganisations = [
      {
        name: 'name',
        label: 'Name',
        field: 'name',
        sortable: true,
        align: 'left',
      },
    ];
    const scTimer = ref(0);
    const scY = ref(0);
    const handleScroll = () => {
      if (scTimer.value) return;
      scTimer.value = setTimeout(() => {
        scY.value = window.scrollY;
        clearTimeout(scTimer.value);
        scTimer.value = 0;
      }, 100);
    };

    const toTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    const scrollToIt = (el) => {
      const yOffset = -80;
      const element = document.getElementById(el);
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    };

    const download = async (documentId, documentName) => {
      await grantsService.downloadDocument(documentId).then((response) => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        );
        var a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = documentName;
        a.href = fileURL;
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      });
    };

    const schemeDeadline = computed({
      get: () =>
        store.state.grantItems.selectedGrant.currentDeadline != null
          ? moment(store.state.grantItems.selectedGrant.currentDeadline).format(
              'DD-MM-YYYY'
            )
          : null,
    });

    const hasOlderNews = ref(false);

    const isNewsInLastYear = (date) => {
      var today = new Date();
      var dateLimitLastYear = new Date().setDate(today.getDate() - 365);
      var newsDate = moment(date).format('YYYY-MM-DD');
      var limit = moment(dateLimitLastYear).format('YYYY-MM-DD');

      if (moment(newsDate).isSameOrAfter(moment(limit))) return true;

      hasOlderNews.value = true;
      return false;
    };

    const showOlderNews = () => {
      showOlderNewsToggle.value = true;
    };

    const hideOlderNews = () => {
      showOlderNewsToggle.value = false;
    };

    const seeMoreNews = (title) => {
      store.commit('newsSearch/updateSearchText', title);

      router.push({
        name: 'News',
      });
    };

    const showOlderNewsToggle = ref(false);

    const toggleShowMore = () => (showMore.value = !showMore.value);

    const shareGrant = () => {
      store.commit('grantItems/enableShareGrant', scheme);
    };

    const enableSaveScheme = (id) => {
      store.commit('grantItems/addSelected', id);
      store.commit('user/enableSaveScheme');
    };

    const formattedMaxAmount = computed({
      get: () => store.state.grantItems.selectedGrantMax,
    });

    const formattedMinAmount = computed({
      get: () => store.state.grantItems.selectedGrantMin,
    });

    const newsInLastYear = computed({
      get: () => store.state.grantItems.newsInLastYear,
    });
    const olderNews = computed({
      get: () => store.state.grantItems.olderNews,
    });

    const areGrantDetailsLoading = computed({
      get: () => store.state.grantItems.areGrantDetailsLoading,
    });

    const downloadScheme = async (schemeId) => {
      let form = document.createElement('form');
      form.method = 'post';
      form.target = '_blank';
      form.action = `/api/download/downloadScheme?id=${schemeId}`;
      form.innerHTML = `'<input type="hidden" name="jwtToken" value="${
        authHeader().Authorization
      }">'`;
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    };

    const formatDate = (stringDate) => {
      const dateN = new Date(stringDate);
      return moment(dateN).format('DD-MM-YYYY');
    };

    const openDetailsInNewTab = computed({
      get: () => store.state.user.openDetailsInNewTab,
    });

    const goToParent = () => {
      router.push({
        name: 'GrantDetails',
        params: { grantId: scheme.value.parentSchemeId },
      });
    };
    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const statusNL = ref('');

    const organisationsList = computed({
      get: () => store.state.grantItems.organisationsList,
    });

    const sortedLinksAndDocs = computed({
      get: () => store.state.grantItems.sortedLinksAndDocs,
    });

    const seeDeprecatedItems = ref(false);

    const updateSeeDeprecatedItems = (val) => {
      seeDeprecatedItems.value = val;
    };

    const isContrast = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });
    return {
      isContrast,
      updateSeeDeprecatedItems,
      seeDeprecatedItems,
      sortedLinksAndDocs,
      organisationsList,
      isVind,
      goToParent,
      router,
      openDetailsInNewTab,
      formatDate,
      statusNL,
      downloadScheme,
      areGrantDetailsLoading,
      newsInLastYear,
      olderNews,
      formattedMaxAmount,
      formattedMinAmount,
      enableSaveScheme,
      shareGrant,
      seeMoreNews,
      showOlderNews,
      showOlderNewsToggle,
      hasOlderNews,
      hideOlderNews,
      isNewsInLastYear,
      schemeDeadline,
      download,
      scrollToIt,
      handleScroll,
      toTop,
      scTimer,
      scY,
      columns,
      route,
      scheme,
      shortIntro,
      showMore,
      toggleShowMore,
      columnsOrganisations,
      iconBasedOnExtension(extension) {
        switch (extension) {
          case '.pdf':
            return 'las la-2x la-file-pdf';
          case '.doc':
            return 'las la-2x la-file-word';
          case '.docx':
            return 'las la-2x la-file-word';
          case '.xls':
            return 'las la-2x la-file-excel';
          case '.xlsx':
            return 'las la-2x la-file-excel';
          case '.csv':
            return 'las la-2x la-file-csv';
          case '.txt':
            return 'las la-2x la-file';
          default:
            return 'las la-2x la-file';
        }
      },
      getChanceOfSuccessRatingColor(rating) {
        switch (rating) {
          case 1:
            return 'negative';
          case 2:
            return 'orange-6';
          case 3:
            return 'yellow-12';
          case 4:
            return 'light-green-13';
          case 5:
            return 'green-10';
          default:
            return 'blue-grey-2';
        }
      },
      getRatingColor(rating) {
        switch (rating) {
          case 1:
            return 'green-10';
          case 2:
            return 'light-green-13';
          case 3:
            return 'yellow-12';
          case 4:
            return 'orange-6';
          case 5:
            return 'negative';
          default:
            return 'blue-grey-2';
        }
      },
      getTimeForApplicationRatingLabel(rating)
      {
        switch (rating) {
          case 5:
            return 'Heel lang';
          case 4:
            return 'Langzaam';
          case 3:
            return 'Gemiddeld';
          case 2:
            return 'Snel';
          case 1:
            return 'Heel snel';
          default:
            return 'Tijdsduur';
        }
      },
      getChanceOfSuccessRatingLabel(rating)
      {
        switch (rating) {
          case 1:
            return 'Heel klein';
          case 2:
            return 'Klein';
          case 3:
            return 'Gemiddeld';
          case 4:
            return 'Groot';
          case 5:
            return 'Heel groot';
          default:
            return 'Slaagkans';
        }
      },
      getComplexityRatingLabel(rating)
      {
        switch (rating) {
          case 5:
            return 'Heel moeilijk';
          case 4:
            return 'Moeilijk';
          case 3:
            return 'Gemiddeld';
          case 2:
            return 'Eenvoudig';
          case 1:
            return 'Heel eenvoudig';
          default:
            return 'Moeilijkheid';
        }
      }
    };
  },
};
</script>
